import { render, staticRenderFns } from "./DialogNoteTextarea.vue?vue&type=template&id=ea3530ee&"
import script from "./DialogNoteTextarea.vue?vue&type=script&lang=js&"
export * from "./DialogNoteTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports